import * as CoursesActions from '../actions/coursesActions';
import {
    addNewChapterTransformation, deleteChapterPartTransformation, deleteOneChapterTransformation,
    editChapterInformationTransformation, handleVisibleChangeTransformation, addNewCourseTransformation
} from "../../utils/chapterDataTransformation";
import {addSubjectToCourse} from '../../utils/CourseSubjectsTransformations';
import {ACTION_COURSE_ADDED} from "../actions/coursesActions";
import {deleteCourseTransformation, deleteSubjectTransformation, approveRequestTransformation,
    addUserToCourseTransformation, removeCourseUserTransformation, getTestsFromCourseTransformation} from "../../utils/CourseTransformations";
import {NotificationManager} from 'react-notifications';

const defaultState = {
    courses: [],
    subjects: [],
    pending: [],
    showModalDeletePart: false,
    partId: '',
    tests: [],
    chapterTests: [],
    testId: '',
    events: [],
    studentCount: 0,
    studentOnlineCount: 0,
    error: null,
    students: [],
    instructors: [],
    activeCourse: null,
    chart: null,
    chartLoading: false,
    chartError: '',
    chartX: [],
    chartType: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case 'CLEAR_CHART':
            return {
                ...state,
                chart: null,
                chartLoading: true,
                chartError: '',
                chartX: [],
                chartType: ''
            }
        case 'CHART_ERROR':
            return {
                ...state,
                chart: null,
                chartLoading: false,
                chartError: action.payload,
                chartX: [],
                chartType: ''
            }
        case 'GOT_CHART':
            return {
                ...state,
                chart: action.payload.chart,
                chartError: '',
                chartLoading: false,
                chartX: action.payload.chartX,
                chartType: action.payload.view
            }
        case 'DELETED_COURSE_TEST':
            return {
                ...state,
                chapterTests: state.chapterTests.filter(t => t.id !== action.payload)
            }
        case 'GOT_PENDING':
            return {
                ...state,
                pending: action.payload
            }
        case 'GOT_ALL_TESTS':
            return {
                ...state,
                chapterTests: action.payload
            }
        case CoursesActions.CHAPTER_TEST_RETRIEVED:
            return {
                ...state,
                activeCourse: {
                    ...state.activeCourse,
                    CourseSubject: state.activeCourse.CourseSubject.map(sub => {
                        if(sub.id === action.payload.courseSubjectId){
                            return {
                                ...sub,
                                CourseChapter: sub.CourseChapter.map(chapter => {
                                    if(chapter.id === action.payload.subjectChapterId){
                                        return {
                                            ...chapter,
                                            ChapterVideo: chapter.ChapterVideo.concat(action.payload)
                                        }
                                    }else{
                                        return chapter
                                    }
                                }) 
                            }
                        }else{
                            return sub
                        }
                    })
                }
            };
        case CoursesActions.SET_ACTIVE_COURSE:
            return {
                ...state,
                activeCourse: {
                    ...action.payload,
                    CourseSubject: action.payload.CourseSubject ? action.payload.CourseSubject.map(s => {
                        return {
                            ...s,
                            loading: true
                        }
                    }) : []
                }
            };
        case CoursesActions.ACTION_SUBJECTS_RETRIEVED:
            return {
                ...state,
                subjects: action.payload
            };
        case CoursesActions.ACTION_ADD_COURSE_USER_FAILED:
            return {
                ...state,
                error: "User already exists"
            };
        case 'ADDED_SUBJECT':
            return {
                ...state,
                activeCourse: {
                    ...state.activeCourse,
                    CourseSubject: state.activeCourse.CourseSubject.concat({
                        ...action.payload,
                    CourseChapter: []})
                }
            }
            break;
        case 'UPDATE_COURSE':
            return {
                ...state,
                activeCourse: state.activeCourse ? state.activeCourse.id === action.payload.id ? {
                    ...state.activeCourse,
                    ...action.payload
                } : state.activeCourse : state.activeCourse,
                courses: state.courses.map(c => {
                    if (c.id === action.payload.id) {
                        return {
                            ...c,
                            ...action.payload
                        }
                    }else{
                        return c
                    }
                })
            }
        case CoursesActions.FAKE_UPDATE_SUBJECT:
            return {
                ...state,
                activeCourse: {
                    ...state.activeCourse,
                    CourseSubject: state.activeCourse.CourseSubject.map(sub => {
                        if(sub.id === action.payload.id){
                            return {
                                ...sub,
                                ...action.payload
                            }
                        }else{
                            return {
                                ...sub
                            }
                        }
                    })
                }
                
            }
        case CoursesActions.ACTION_DELETED_CHAPTER_FILE:
            return {
                ...state,
                courses: state.courses.map(course => {
                    return {
                        ...course,
                        CourseSubject: course.CourseSubject.map(sub => {
                            return {
                                ...sub,
                                CourseChapter: sub.CourseChapter.sort(function(a,b) {
                                    return (a.number > b.number) ? 1 : ((b.number > a.number) ? -1 : 0)
                                } ).map(chapter => {
                                    return {
                                        ...chapter,
                                        File: chapter.File.filter(f => f.id !== action.payload)
                                    }
                                })
                            }
                        })
                    }
                })
            }
        case CoursesActions.ACTION_COURSE_RETRIEVED:

            return {
                ...state,
                error: null,
                courses: action.payload
            };
        case CoursesActions.ACTION_SUBJECT_ADDED:
            return {
                ...state,
                courses: addSubjectToCourse(state.courses, action.payload)

            };
        case CoursesActions.ACTION_REMOVED_COURSE_USER:
            return {
                ...state,
                pending: state.pending.filter(s => s.id !== action.payload),
                students: state.students.filter(s => s.id !== action.payload),
                error: null
            };
        case CoursesActions.ACTION_SUBJECT_DELETED:
            return {
                ...state,
                activeCourse: {
                    ...state.activeCourse,
                    CourseSubject: state.activeCourse.CourseSubject.filter(s => s.id !== action.payload)
                },
                error: null
            };
        case CoursesActions.ACTION_APPROVED_REQUEST:
            return {
                ...state,
                pending: state.pending.filter(p => p.id !== action.payload),
                error: null
            };
        case CoursesActions.ACTION_ADDED_COURSE_USER:
            return {
                ...state,
                courses: addUserToCourseTransformation(state.courses, action.payload),
                error: null
            };
        case CoursesActions.ACTION_COURSE_DELETED:
            return {
                ...state,
                courses: deleteCourseTransformation(state.courses, action.payload),
                activeCourse: state.activeCourse.id == action.payload ? {} : state.activeCourse
            };
        case CoursesActions.ACTION_SHOW_MODAL_DELETE_PART:
            return {
                ...state,
                showModalDeletePart: true,
                partId: action.payload
            };
        case CoursesActions.ACTION_HIDE_MODAL_DELETE_PART:
            return {
                ...state,
                showModalDeletePart: false
            };
        case CoursesActions.ACTION_DELETE_CHAPTER_PART:
            return {
                ...state,
                activeCourse: {...state.activeCourse,
                    CourseSubject: state.activeCourse.CourseSubject.map((subject) => {
                        return {
                            ...subject,
                            CourseChapter: subject.CourseChapter ? subject.CourseChapter.map((chapter) => {
                                return {
                                    ...chapter,
                                    ChapterVideo: chapter.ChapterVideo ? chapter.ChapterVideo.filter((part) => {
                                        return part.id !== action.payload
                                    }) : []
                                }
    
                            }) : []
                        }
    
                    })
                }
            };
        case CoursesActions.ACTION_EDIT_CHAPTER_INFORMATION:
            return {
                ...state,
                subjects: editChapterInformationTransformation(state.subjects, action.payload)
            };
        case CoursesActions.ACTION_ADD_NEW_CHAPTER:
            return {
                ...state,
                courses: action.payload
            };
        case 'ADDED_CHAPTER':
            return {
                ...state,
                activeCourse: {
                    ...state.activeCourse,
                    CourseSubject: state.activeCourse.CourseSubject.map(sub => {
                        if(sub.id === action.payload.courseSubjectId){
                            return {
                                ...sub,
                                CourseChapter: sub.CourseChapter.concat({
                                    ...action.payload,
                                    ChapterVideo: []
                                })
                            }
                        }else{
                            return sub
                        }
                    })
                }
            }
        case CoursesActions.ACTION_DELETE_ONE_CHAPTER:
            return {
                ...state,
                activeCourse: {
                    ...state.activeCourse,
                    CourseSubject: state.activeCourse.CourseSubject.map(sub => {
                        return {
                            ...sub,
                            CourseChapter: sub.CourseChapter.filter(ch => ch.id !== action.payload)
                        }
                    })
                }                

                //subjects: deleteOneChapterTransformation(state.subjects, action.payload)
            };
        case CoursesActions.ACTION_CHANGE_VISIBLE_COURSES:
            return {
                ...state,
                subjects: handleVisibleChangeTransformation(state.subjects, action.payload)
            };
        case CoursesActions.ACTION_DELETE_TEST_ASSIGNED:
            return {
                ...state,
                subjects: deleteOneChapterTransformation(state.subjects, action.payload)
            };
        case CoursesActions.ACTION_ADD_NEW_COURSE:
            return{
                ...state,
                subjects: addNewCourseTransformation(state.subjects, action.payload)
            };
        case CoursesActions.ACTION_COURSE_ADDED:
            NotificationManager.success('Your course has been created.', 'Saved');
            return {
                ...state,
                courses: state.courses.concat(action.payload),
                error: null
            };
        case CoursesActions.ACTION_TEST_RETRIEVED:

            return {
                ...state,
                tests: (Array.isArray(action.payload)) ? action.payload : state.tests.map(t => {
                    if(t.id === action.payload.id){
                        return {
                            ...action.payload
                        }
                    }else{
                        return {...t}
                    }
                })
            };
        case CoursesActions.ACTION_TEST_ADDED:
            NotificationManager.success('Your diagnostic test has been saved.', 'Saved');
            return {
                ...state,
                tests: state.tests.concat(action.payload),
                testId: action.payload.id
            };
        case CoursesActions.ACTION_TEST_DELETED:
            return {
                ...state,
                tests: state.tests.filter(test => test.id !== action.payload)
            };
        case CoursesActions.ACTION_COURSE_UPDATED:
            NotificationManager.success('Your course data has been saved.', 'Saved');
            let courses = state.courses.map(c => {
                if(c.id === action.payload.id){
                    return {...c, ...action.payload}
                }else{
                    return c
                }
            });

            return {
                ...state,
                courses: courses,
                error: null
            };
        case CoursesActions.EVENT_CREATED:
            return {
                ...state,
                events: state.events.concat(action.payload)
            };
        case CoursesActions.EVENTS_RETRIEVED:
            return {
                ...state,
                events: action.payload
            };

        case CoursesActions.ACTION_GOT_INSTRUCTORS:
            return {
                ...state,
                instructors: action.payload
            };

        case CoursesActions.ACTION_GOT_STUDENTS:
            return {
                ...state,
                students: action.skip ? state.students.concat(action.payload) : action.payload
            };
        case 'GOT_VQ_COUNT': 
            return {
                ...state,
                activeCourse: {
                    ...state.activeCourse,
                    CourseSubject: state.activeCourse.CourseSubject.map(s => {
                        if(s.id === action.payload.subjectId){
                            return {
                                ...s,
                                CourseChapter: s.CourseChapter ? s.CourseChapter.map(chapter => {
                                    if(chapter.id === action.payload.chapterId){
                                        return {
                                            ...chapter,
                                            ChapterVideo: chapter.ChapterVideo.map(v => {
                                                if(v.id === action.payload.id){
                                                    return {
                                                        ...v,
                                                        videoQuestionCount: action.payload.count
                                                    }
                                                }else{
                                                    return v
                                                }
                                            })
                                        }
                                    }else {
                                        return chapter
                                    }
                                }) : []
                            }
                        }else{
                            return s
                        }
                    })
                }
            }
        case 'GOT_QQ_COUNT': 
            return {
                ...state,
                activeCourse: {
                    ...state.activeCourse,
                    CourseSubject: state.activeCourse.CourseSubject.map(s => {
                        if(s.id === action.payload.subjectId){
                            return {
                                ...s,
                                CourseChapter: s.CourseChapter ? s.CourseChapter.map(chapter => {
                                    if(chapter.id === action.payload.chapterId){
                                        return {
                                            ...chapter,
                                            ChapterVideo: chapter.ChapterVideo.map(v => {
                                                if(v.id === action.payload.id){
                                                    return {
                                                        ...v,
                                                        quizQuestionCount: action.payload.count
                                                    }
                                                }else{
                                                    return v
                                                }
                                            })
                                        }
                                    }else {
                                        return chapter
                                    }
                                }) : []
                            }
                        }else{
                            return s
                        }
                    })
                }
            }
        case 'GOT_SINGLE_SUBJECT': 
            return {
                ...state,
                activeCourse: {
                    ...state.activeCourse,
                    CourseSubject: state.activeCourse.CourseSubject.map(s => {
                        if(s.id === action.payload.id){
                            return {
                                ...s,
                                ...action.payload,
                                loading: false
                            }
                        }else{
                            return s
                        }
                    })
                }
            }
        
        case 'GOT_STUDENT_COUNT':
            return {
                ...state,
                studentCount: action.payload
            }

        case CoursesActions.ACTION_STUDENT_UPDATED:
            return {
                ...state,
                students: state.students.map(student => {
                    if(student.id == action.payload.id){
                        return {
                            ...student,
                            ...action.payload
                        }
                    }else{
                        return {
                            ...student
                        }
                    }
                })
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/coursesReducer.js